export enum ProductMachineOperationRateActionsTypes {
  READ = "@@PRODUCT_MACHINE_OPERATION_RATE read",
  READ_STATUS = "@@PRODUCT_MACHINE_OPERATION_RATE read status"
}
